import { render, staticRenderFns } from "./UnitSingleImage.vue?vue&type=template&id=2a69f080&scoped=true&"
import script from "./UnitSingleImage.vue?vue&type=script&lang=js&"
export * from "./UnitSingleImage.vue?vue&type=script&lang=js&"
import style0 from "./UnitSingleImage.vue?vue&type=style&index=0&id=2a69f080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a69f080",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
